// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1IVWg","file":"styles_file__3jKtF"};